import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  Modal,
  Text,
  Select,
  Flex,
  Spacer
} from "@oliasoft-open-source/react-ui-library";
import translations from "client/internationalization/translation-map.json";
import { AssociatedData } from "client/components/data-viewer/associated-data-viewer/associated-data-viewer";
import { EntityType } from "common/enums/entity-enums";
import { IObject } from "common/interfaces/hierarchy-entities";

type AssociatedDataModalProps = {
  linkedItems: IObject[];
  dataObject: IObject | null;
  onClose: () => void,
  setSelectedData?: Dispatch<SetStateAction<IObject | null>>;
}

export const AssociatedDataModal = ({
  linkedItems,
  dataObject,
  onClose,
  setSelectedData
}: AssociatedDataModalProps) => {
  const { t } = useTranslation();
  const [selectedItem, setSelectedItem] = useState<IObject | null>(linkedItems[0]);

  const isLinkedToMultiple = linkedItems?.length > 1;
  const content = (
    <>
      {isLinkedToMultiple && (
        <>
          <Text>{t(translations.objects_linkedItemModalTitle, { name: dataObject?.name, type: dataObject?.type })}</Text>
          <Flex alignItems="center" gap="var(--padding-xs)">
            <Select
              value={selectedItem?.objectid}
              options={linkedItems?.map(item => ({ value: item?.objectid, label: item?.associateddata?.surveyRunName }))}
              onChange={(e) => {
                const selected = linkedItems.find(item => item.objectid === e.target.value);
                setSelectedItem(selected || null);
              }}
              width="70%"
            />
            <Button round basic colored="muted" icon="link"
              onClick={() => {
                const selected = linkedItems.find(item => item.objectid === selectedItem?.objectid);
                setSelectedData?.(selected || null);
                onClose();
              }} />
          </Flex>
          <Spacer />
        </>
      )}
      {selectedItem && (
        <AssociatedData
          objectid={selectedItem.objectid}
          nodeid={selectedItem?.associateddata?.nodeid}
          designid={selectedItem?.metadata.hierarchyData?.design?.id}
          entityType={selectedItem?.associateddata?.type as EntityType}
          archiveid={selectedItem?.metadata?.hierarchyData?.archive?.id}
          viewOnly={true}
        />
      )}
    </>
  );

  const heading = isLinkedToMultiple ?  t(translations.selectItem) : `${selectedItem?.associateddata?.type} - ${selectedItem?.associateddata?.surveyRunName}`;

  return (
    <Modal centered visible onEscape={onClose}>
      <Dialog
        dialog={{
          heading,
          content,
          footer: (
            <Button
              label={t(translations.cancel)}
              onClick={onClose}
            />
          ),
          onClose,
        }}
      />
    </Modal>
  );
};
